export default "__VITE_ASSET__CKEoq4zZ__"